/** AED major units (`12.5`) to minor units (`1250`). Empty when the amount is not a positive two-decimal value. */
export const toMinorUnits = (input: string): string | undefined => {
  const match = /^(\d+)(?:\.(\d{1,2}))?$/.exec(input.trim());
  if (!match || match[1].length > 13) return undefined;

  const minor =
    BigInt(match[1]) * BigInt(100) + BigInt((match[2] ?? "").padEnd(2, "0"));
  if (minor <= BigInt(0)) return undefined;
  return minor.toString();
};
